/* eslint-disable camelcase */
import { pushToDataLayer } from '../pushToDataLayer';

/**
 * Attaches event listeners to forms for analytics tracking.
 * Depending on the form type, different events are pushed to the dataLayer.
 */
const formListeners = () => {
  const $form = $('.js-form');

  if (!$form.length) {
    return;
  }

  const formType = $form.data('formtype').toLowerCase().replace(/\s/g, '');
  const formId = $('form').attr('id');
  let isAnalyticsPushed = false;

  switch (formType) {
    case 'contactus':
      pushToDataLayer({
        event: 'ga4_form_visible',
        ga4_data: {
          form_name: 'Contact us',
          form_id: formId
        }
      });
      break;
    case 'newsletter':
      pushToDataLayer({
        event: 'ga4_form_visible',
        ga4_data: {
          form_name: 'Newsletter form',
          form_id: formId
        }
      });
      break;
    case 'askthedoctor':
      pushToDataLayer({
        event: 'ga4_form_visible',
        ga4_data: {
          form_name: 'Ask the doctor',
          form_id: formId
        }
      });
      break;
    default:
      break;
  }

  const triggerFormFillEvent = (formName) => {
    pushToDataLayer({
      event: 'ga4_form_start',
      ga4_data: {
        form_name: formName,
        form_id: formId
      }
    });
  };

  $form.find('.form-field').on('change', () => {
    if (!isAnalyticsPushed) {
      switch (formType) {
        case 'contactus':
          triggerFormFillEvent('Contact us');
          break;
        case 'newsletter':
          triggerFormFillEvent('Newsletter form');
          break;
        case 'askthedoctor':
          triggerFormFillEvent('Ask the doctor');
          break;
      }
      isAnalyticsPushed = true;
    }
  });
}

export const addFormListeners = () => {
  formListeners();
};
